export default "__VITE_ASSET__50Vvof8v__"